import { render } from "./Modele_2.vue?vue&type=template&id=3e192f4d&scoped=true"
import script from "./Modele_2.vue?vue&type=script&lang=js"
export * from "./Modele_2.vue?vue&type=script&lang=js"

import "./Modele_2.vue?vue&type=style&index=0&id=3e192f4d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e192f4d"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
